import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { ProfileSetupScreen } from '../screens/onboarding/ProfileSetupScreen';
import type { OnboardingStackParamList } from './types';
import { pastelNavigationTheme } from './theme';

const Stack = createNativeStackNavigator<OnboardingStackParamList>();

export function OnboardingNavigator() {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: true,
        headerStyle: { backgroundColor: '#fff1f2' },
        headerTintColor: '#1f2937',
        headerShadowVisible: false,
        headerTitleStyle: { fontWeight: '600' },
        contentStyle: { backgroundColor: pastelNavigationTheme.colors.background },
      }}>
      <Stack.Screen
        name="ProfileSetup"
        component={ProfileSetupScreen}
        options={{ title: 'Profilini tamamla' }}
      />
    </Stack.Navigator>
  );
}
